import React, { useEffect, useState } from "react";
import { Card, Col, Button, Row, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import ProjectBar from "./ProjectBar";

const Design = () => {
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    fetch("./projects.json")
      .then((res) => res.json())
      .then((data) => setProjects(data));
  }, []);
  return (
    <div id="fullstack" className="my-5 whole">
      <Container>
        <Row
          xs={1}
          md={2}
          className="mb-2 d-flex justify-content-center align-items-center gx-5 gy-5"
        >
          {projects.slice(5, 20).map((project) => (
            <Col project={project} key={project.key}>
              <div className="card mx-auto border-0 p-2 w-100">
                <div className="image">
                  <img className="w-100" src={project.img} alt="" />
                </div>
                <div className="details">
                  <div className="center">
                    <h4> {project.name} </h4>
                    <p>Short Description : {project.niche}</p>
                    <p>
                      <Button
                        className="text-light me-3 live rounded-pill"
                        variant="success"
                        size="md"
                      >
                        <a href={project.live}>Live Site</a>
                      </Button>

                      <Link to={`/projects/${project.key}`}>
                        <Button
                          className="banner-button text-light rounded-pill"
                          variant="success"
                          size="md"
                        >
                          Details
                        </Button>
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
      <div className="align-items-center justify-content-center text-center pt-3">
        <Button
          className="text-light me-3 live rounded-pill px-5 "
          variant="success"
          size="md"
        >
          <a
            href="https://github.com/ShahriarAhmod?tab=repositories"
            target="blank"
          >
            See More
          </a>
        </Button>
        {/* <button className="btn btn-success ">See More</button> */}
      </div>
    </div>
  );
};

export default Design;
